export const DEFAULT_ERROR_MESSAGE = 'Ocorreu um erro, tente novamente mais tarde.'

export const COPY_CODE_MESSAGE = 'Copiar código.'

export const COPIED_CODE_MESSAGE = 'Código copiado!'

export const COUPON_ERROR_MESSAGE =
  'Não foi possível gerar seu cupom, tente novamente em alguns minutos'

export const GLOBOPLAY_ERROR_MESSAGE =
  'Ocorreu um erro. Não foi possível acessar o site, tente novamente mais tarde'

export const PIX_PAYMENT_ERROR_MESSAGE = 'Não foi possível buscar o QR Code.'

export const DOWNLOAD_PAID_BILL_MESSAGE =
  'Fatura indisponível para download no momento. Tente novamente mais tarde ou entre em contato com a nossa Central de atendimento'

export const COUPON_BUTTON_LABEL = 'Gerar cupom'
